<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-none d-md-block">
      Copyright © {{ currentYear }} IT DBC
    </span>
  </p>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
}
</script>

<!-- <script>
// import { BLink } from 'bootstrap-vue'

export default {
  components: {
    // BLink,
  },
}
</script> -->
